import { differenceInCalendarDays, differenceInMinutes } from 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';
import { Text } from 'trpc-react-native-ui';
import { dateUtils } from '../../lib/date-utils';

const DateTimeLabel = props => {
  const currentTime = Date.now();
  const timestamp = props.timestamp;

  const formatDistanceLessOneMinute = () =>
    differenceInMinutes(currentTime, timestamp) < 1
      ? dateUtils.formatDistance(timestamp, currentTime)
      : dateUtils.formatDistanceStrict(timestamp, currentTime);

  const value =
    differenceInCalendarDays(currentTime, timestamp) > 3
      ? dateUtils.format(timestamp, 'PP p')
      : formatDistanceLessOneMinute();

  return <Text style={props.style}>{value}</Text>;
};

DateTimeLabel.propTypes = {
  timestamp: PropTypes.number.isRequired,
  style: PropTypes.any,
};

export default DateTimeLabel;
